import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthGuard } from '@next/core-lib/authorization';

import { OverviewComponent } from './overview.component';

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: OverviewComponent,
        canActivate: [AuthGuard],
      },
    ]),
  ],
})
export class OverviewRoutingModule {}
